exports.LOGTYPE = {
  EXAM: 1,
};

exports.SENDTYPE = {
  EMAIL: 1,
  SMS: 2,
};

exports.ACCOUNTTYPE = {
  ADMIN: 1, //관리자
  RATER: 2, //평가자
  TESTER: 100, //응시자
};

exports.ORDERTYPE = {
  TESTDONE: 1, //응시완료
  NAME: 2, //이름
};

exports.OVERSEA = {
  ONE: 1, // 6개월 미만
  TWO: 2, // 6개월 ~ 1년 미만
  THR: 3, // 1년 이상
  FOU: 4,
  FIV: 5,
  SIX: 6,
};

exports.GETOVERSEATEXT = (OVERSEA) => {
  switch (OVERSEA) {
    case this.OVERSEA.ONE:
      return "6개월 미만";
    case this.OVERSEA.TWO:
      return "6개월 ~ 1년 미만";
    case this.OVERSEA.THR:
      return "1년 이상";
    default :
      return "6개월 미만";
  }
};

exports.EVALUATION_ITEM_TYPE ={
  CHOICE : 1,//객관식
  SUBJECTIVE : 2,//주관식
}
